export const DEVELOPMENT_BASE_URL = 'http://192.168.0.19';
export const PRODUCTION_BASE_URL = '';
export const BASE_URL = process.env.NODE_ENV === 'production' ?
    PRODUCTION_BASE_URL : DEVELOPMENT_BASE_URL;
